import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getTracksHome } from "../api/getTracksHome";

class TrackHomeListContainer extends React.Component {
  componentDidMount() {
    const { days } = this.props;
    this.props.request(days);
  }

  componentDidUpdate(prevProps) {
    if (this.props.days !== prevProps.days) {
      this.props.request(this.props.days);
    }
  }
  render = () => {
    const { days, data, loading, failure, render } = this.props;
    const tracks = (data && data.data && data.data.tracks) || [];
    const date = (data && data.data && data.data.date) || [];
    const daysAgo = days;
    return render({ tracks, date, daysAgo, loading, failure });
  };
}

TrackHomeListContainer.propTypes = {
  days: PropTypes.number
};

TrackHomeListContainer.defaultProps = {
  days: 0
};

export default CreateContainer(getTracksHome, TrackHomeListContainer);
